import {
  BodyAutorizacionOrden,
  ContainerAutorizacionOrden,
  TopAutorizacionOrden,
} from "./localStyle";
import imageOrden from "../../../assets/images/generico/OrdenMiniatura.png";
import { useState } from "react";
import { Camera, CameraResultType } from '@capacitor/camera';
import { getPlatforms } from "@ionic/react";

const AutorizacionOrden = ({
  flgAutocheck,
  idTurno,
  finalizarProceso,
  dissmiss,
}) => {
  const [step, setStep] = useState("consulta"); // confirmar
  const [imageCamera, setImageCamera] = useState("");
  // const onClickFirma = () => {};
  // const onChangeFirma = () => {};
  // const flgAutocheck = true;

  let isMobile =
    getPlatforms()[0] === "android" ||
    getPlatforms()[0] === "ios" ||
    getPlatforms()[0] === "iphone"
      ? true
      : false;

  const handleClick = () => {
    const takePicture = async () => {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
      });
      const imageUrl = image.dataUrl;
      setImageCamera(imageUrl);
      setStep("");
    };
    takePicture();
  };
  const tipoImage = (url) => {
    url = url.split(",");
    const type = url[0].replace("data:image/", "").replace("base64", "");
    const base64 = url[1];
    return {
      type,
      base64,
    };
  };

  const handleClickConfirmarOrden = (isCorrect) => {
    if (isCorrect) {
      const obj = tipoImage(imageCamera);
      const imageFinish = {
        binario: obj.base64,
        idRemoto: idTurno,
        tag: obj.type,
        autocheck: flgAutocheck,
      };
      finalizarProceso([imageFinish], true);
    } else {
      setStep("consulta");
      setImageCamera("");
    }
  };

  return (
    <ContainerAutorizacionOrden isMobile={isMobile}>
      {step === "consulta" ? (
        <>
          <TopAutorizacionOrden>
            <h1>Imagen de autorización</h1>
            <span className="cruz" onClick={dissmiss}>
              X
            </span>
          </TopAutorizacionOrden>
          <BodyAutorizacionOrden lessGap={false}>
            <span>
              El turno requiere autorización, ingrese una imagen de la misma.
            </span>
            <img src={imageOrden} alt="ordenes" />
            <button onClick={handleClick}>Subir</button>
          </BodyAutorizacionOrden>
        </>
      ) : (
        <>
          <TopAutorizacionOrden>
            <h1>Imagen de autorización</h1>
          </TopAutorizacionOrden>
          <BodyAutorizacionOrden lessGap={true}>
            <h1>¿El frente de orden se visualiza correctamente?</h1>
            <img
              className="image-current"
              src={imageCamera}
              alt="comprobación de orden"
            />
            <div className="btn-container">
              <button
                onClick={() => handleClickConfirmarOrden(true)}
                className="success"
              >
                SI
              </button>
              <button
                onClick={() => handleClickConfirmarOrden(false)}
                className="danger"
              >
                NO
              </button>
            </div>
          </BodyAutorizacionOrden>
        </>
      )}
    </ContainerAutorizacionOrden>
  );
};

export default AutorizacionOrden;
